import React from 'react';
import { motion } from 'framer-motion';
import { Star, Package, Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden bg-white pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-132">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-134">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-135">
            <span className="inline-block py-1 px-3 rounded-full bg-[#4DBFB8]/10 text-[#4DBFB8] font-bold text-sm tracking-wide mb-6" data-id="element-136">
              ANIFIT SAMENWERKING MET STRESSLESS DOGS
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6" data-id="element-137">
              <span className="text-[#4DBFB8]" data-id="element-138">Anifit Promo Actie</span>:
              Gebruik code "stressless" voor 10% korting & afgestemd
              voedingsadvies
            </h1>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-139">
              Bij gebruik van de vouchercode neemt Stressless Dogs na je
              bestelling bij Anifit contact op om een voedingsadviesplan op te
              stellen. Ook kan je zelf altijd vragen mailen naar{' '}
              <a href="mailto:amee@stresslessdogs.nl" className="text-[#4DBFB8] font-bold underline" data-id="element-140">
                amee@stresslessdogs.nl
              </a>
              .
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mb-8 text-sm font-medium text-gray-700" data-id="element-141">
              <div className="flex items-center" data-id="element-142">
                <div className="flex text-[#E85D5D]" role="img" aria-label="5 sterren beoordeling" data-id="element-143">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-144" />)}
                </div>
              </div>
              <span className="hidden sm:inline text-gray-300" aria-hidden="true" data-id="element-145">
                |
              </span>
              <div className="flex items-center gap-2" data-id="element-146">
                <Package className="w-5 h-5 text-[#4DBFB8]" aria-hidden="true" data-id="element-147" />
                <span data-id="element-148">Gratis verzending vanaf €200</span>
              </div>
              <span className="hidden sm:inline text-gray-300" aria-hidden="true" data-id="element-149">
                |
              </span>
              <div className="flex items-center gap-2" data-id="element-150">
                <span className="text-xl" role="img" aria-label="Zweedse vlag" data-id="element-151">
                  🇸🇪
                </span>
                <span data-id="element-152">Zweeds kwaliteitsvlees</span>
              </div>
            </div>

            <a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050" target="_blank" rel="noopener noreferrer" aria-label="Gebruik Anifit promo actie met 10% korting" data-id="element-153">
              <Button className="w-full sm:w-auto shadow-xl shadow-[#E85D5D]/20" data-id="element-154">
                GEBRUIK PROMO ACTIE
              </Button>
            </a>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-155">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/x3GExsknAqXKERwsFg6zKP/freepik__row-of-dog-food-cans-on-a-clean-dining-table-in-a-__10482_(1).png" alt="Anifit premium hondenvoer blikken met vers vlees op tafel met gelukkige golden retriever hond" loading="eager" className="w-full h-full object-cover" data-id="element-157" />

              {/* Decorative circle */}
              <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-[#4DBFB8]/10 rounded-full blur-3xl" aria-hidden="true" data-id="element-158"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}